import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function FloatingTextBubble({
  top,
  left,
  bottom,
  right,
  text,
  linkReportText,
  linkReportHref,
  linkCalendarText,
  linkCalendarHref,
  width = 275,
  zIndex = 50,
}) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [isReportHovered, setIsReportHovered] = useState(false);
  const [isCalendarHovered, setIsCalendarHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile device for close button optimization
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    const timer = setTimeout(() => setVisible(true), 3000);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  if (dismissed) return null; // Don't render at all if user closed it

  return (
    <div
      style={{
        position: 'fixed',
        top: top !== undefined ? `${top}px` : undefined,
        left: left !== undefined ? `${left}px` : undefined,
        bottom: bottom !== undefined ? `${bottom}px` : undefined,
        right: right !== undefined ? `${right}px` : undefined,
        width: `${width}px`,
        zIndex,
        borderRadius: '1rem',
        backgroundColor: 'white',
        padding: '1rem',
        boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
        border: '1px solid #d1d5db',
        color: 'black',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 1s ease, transform 0.75s ease',
      }}
    >
      {/* Close button */}
      <button
        onClick={() => setDismissed(true)}
        style={{
          position: 'absolute',
          top: isMobile ? '8px' : '2px',
          right: isMobile ? '12px' : '4px',
          background: 'transparent',
          border: 'none',
          fontSize: isMobile ? '1.75rem' : '1.5rem',
          color: '#aaa',
          cursor: 'pointer',
          padding: isMobile ? '8px 12px' : '4px 8px',
          borderRadius: '4px',
          minHeight: isMobile ? '44px' : 'auto', // iOS accessibility guideline
          minWidth: isMobile ? '44px' : 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onMouseEnter={(e) => e.target.style.color = '#666'}
        onMouseLeave={(e) => e.target.style.color = '#aaa'}
        aria-label="Close"
      >
        &times;
      </button>

      <p style={{ 
        fontSize: '0.875rem', 
        paddingRight: isMobile ? '60px' : '20px',
        marginBottom: '0.5rem'
      }}>
        {text}
      </p>

      {linkReportHref && linkReportText && (
        <Link
          to={linkReportHref}
          onMouseEnter={() => setIsReportHovered(true)}
          onMouseLeave={() => setIsReportHovered(false)}
          style={{
            color: isReportHovered ? '#1d4ed8' : '#2563eb',
            fontSize: '0.875rem',
            marginTop: '0.5rem',
            display: 'inline-block',
            textDecoration: 'underline',
            textShadow: isReportHovered ? '0 1px 2px rgba(29, 78, 216, 0.3)' : 'none',
            transition: 'color 0.2s ease, text-shadow 0.2s ease',
          }}
        >
          {linkReportText} <FontAwesomeIcon icon={faArrowRight} style={{ verticalAlign: 'middle' }} />
        </Link>
      )}

      {linkCalendarHref && linkCalendarText && (
        <Link
          to={linkCalendarHref}
          onMouseEnter={() => setIsCalendarHovered(true)}
          onMouseLeave={() => setIsCalendarHovered(false)}
          style={{
            color: isCalendarHovered ? '#1d4ed8' : '#2563eb',
            fontSize: '0.875rem',
            marginTop: '0.5rem',
            display: 'inline-block',
            textDecoration: 'underline',
            textShadow: isCalendarHovered ? '0 1px 2px rgba(29, 78, 216, 0.3)' : 'none',
            transition: 'color 0.2s ease, text-shadow 0.2s ease',
          }}
        >
          {linkCalendarText} <FontAwesomeIcon icon={faArrowRight} style={{ verticalAlign: 'middle' }} />
        </Link>
      )}
    </div>
  );
}